<template>
    <div class="row">
        <div class="col-12 mt-3">
            <div class="row">
                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.first_name')}}
                </div>
                <div class="col-7 mt-3">
                    <input type="text" maxlength="50" class="form-control" v-model="model.firstname">
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.last_name')}}
                </div>
                <div class="col-7 mt-3">
                    <input type="text" maxlength="50" class="form-control" v-model="model.lastname">
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.email')}}
                </div>
                <div class="col-7 mt-3">
                    <input type="text" maxlength="50" class="form-control" v-model="model.email">
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.phone_number')}}
                </div>
                <div class="col-7 mt-3">
                    <input type="text" maxlength="15" class="form-control" v-model="model.phone_no">
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.language')}}
                </div>
                <div class="col-7 mt-3">
                    <select v-model="model.language" class="form-control" size="1">
                        <option v-for="language in languages" :value="language.code" :key="language.code">{{language.name}}</option>
                    </select>
                </div>

                <div class="col-5 text-right mt-3">
                    {{$t('userprofile.data.location')}}
                </div>
                <div class="col-7 mt-3">
                    <input type="text" maxlength="50" class="form-control" v-model="model.location">
                </div>

                <div class="col-5 text-right mt-3" v-if="userSignature == null && hasFilesReadPermission && hasFilesCreatePermission">
                    <label>{{ $t('table.upload_signature') }}</label>
                </div>
                <div class="col-7 mt-3" v-if="userSignature == null && hasFilesReadPermission && hasFilesCreatePermission">
                    <vue-dropzone class="dropzone" ref="document" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                </div>

                <div class="col-5 text-right mt-3" v-if="userSignature != null && hasFilesReadPermission">
                    <label>{{ $t('table.signature') }}</label>
                </div>
                <div class="col-7 mt-3" v-if="userSignature != null && hasFilesReadPermission">
                    <b-card>
                        <b-img 
                            class="cursor-pointer" 
                            style="max-width: 300px; display: block" 
                            fluid 
                            :src="userSignature" 
                            :title="$t('table.download_image')"
                            :alt="$t('table.signature')"
                            @click="onDownloadFile"
                        />
                        <p 
                            v-if="hasFilesDeletePermission"
                            class="float-right p-0 m-0"
                        >
                            <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile"></i>
                        </p>
                    </b-card>
                </div> 

                <div class="col-5 mt-3 text-right" v-if="profile_picture_name != null">
                    <label>{{ $t('table.profile_picture') }}</label>
                </div>
                <div class="col-7 mt-3" v-if="profile_picture_name != null">
                    <b-card no-body>
                        <b-card-body class="pt-0 pb-0">
                            <div style="width: 100%; display: block">
                                <p 
                                    class="float-left customLink"
                                    :title="profile_picture_name"
                                    @click="onDownloadProfilePicture"
                                >
                                    {{ profile_picture_name }}
                                </p>
                                <p class="float-right p-0 m-0">
                                    <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteProfilePicture"></i>
                                </p>
                            </div>
                        </b-card-body>
                    </b-card>
                </div> 

                <div class="col-12 mt-2">
                    <button type="submit" :disabled="this.$store.state.ajax_in_progress" class="btn btn-success mt-2 float-right" @click="saveAction">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('misc.save_profile')}}
                    </button>
                </div>
            </div>
        </div>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ delete_message }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';

import miniToastr from 'mini-toastr';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

export default {
    name: 'profile_change',
    components: {
        ConfirmDialog,
        miniToastr,
        vueDropzone: vue2Dropzone
    },
    data() {
        return {
            actionTitleDelete: '',
            delete_message: '',

            userSignature: null,
            file_id: null,
            isFileDelete: false,

            hasFilesReadPermission: false,
            hasFilesCreatePermission: false,
            hasFilesDeletePermission: false,

            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                autoProcessQueue: false,
                uploadMultiple: false,
                dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>' + ' ' + Vue.i18n.translate('table.upload_signature'),
                maxFiles: 1,
            },
            getData: {
                getFile: [],
            },
            model: {
                firstname: null,
                lastname: null,
                email: null,
                phone_no: null,
                language: null,
                location: null,
            }
        }
    },
    mounted () {
        this.onLoadUser();
    },
    computed: {
        languages: {
            get: function () {
                let languages = this.$store.getters.getLanguages;
                return languages;
            }
        },
        user_signature: {
            get: function () {
                let user_signature = this.$store.getters.getUserSignature;
                return user_signature;
            }
        },
        profile_picture_name: {
            get: function () {
                let profile_picture_name = this.$store.state.user.user.profile_picture_name;
                return profile_picture_name;
            }
        }
    },
    watch: {
        languages: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        user_signature: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.viewImage(this.user_signature);
                }
            }
        },
        profile_picture_name: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        onLoadUser () {
            this.model.firstname = this.$store.state.user.user.firstname;
            this.model.lastname  = this.$store.state.user.user.lastname;
            this.model.email     = this.$store.state.user.user.email;
            this.model.phone_no  = this.$store.state.user.user.phone_no;
            this.model.language  = this.$store.state.user.user.language;
            this.model.location  = this.$store.state.user.user.location;

            this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
            this.hasFilesCreatePermission = this.$store.getters.hasPermission(['files'], ['create']);
            this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);

            this.viewImage(this.user_signature);
        },
        saveAction () {
            localStorage.setItem('lang', this.model.language);

            this.waitToUploadDocuments().then(res => {
                this.saveUser();
            });
        },
        saveUser () {
            let credentials = {
                id:        this.$store.state.user.user.id,
                firstname: this.model.firstname,
                lastname:  this.model.lastname,
                email:     this.model.email,
                phone_no:  this.model.phone_no,
                language:  this.model.language,
                location:  this.model.location,
            };

            Object.keys(credentials).forEach(key => {
                if (credentials[key] === '') {
                    credentials[key] = null;
                }
            });

            this.$store.commit('SET_LANGUAGE', this.model.language);
            this.$store.dispatch('editUser', credentials).then(res => {
                this.onLoadUser();
            });

            this.$nextTick(() => {
                if (typeof this.$refs.signature != 'undefined') {
                    this.$refs.signature.removeAllFiles();
                }
            });
        },
        async uploadDocuments () {
            return new Promise((resolve, reject) => {
                if (this.hasFilesCreatePermission && typeof this.$refs.document != 'undefined') {
                    var file = this.$refs.document.getQueuedFiles();
                    for (let order = 0; order < file.length; order++) {
                        var formData = new FormData();
                        formData.append('file', file[order]);
                        formData.append('type', 'user_signature');
                        formData.append('user_signature_id', this.$store.state.user.user.id);
                        let data = http.route('file').post(
                            formData,
                                {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(response => {
                            if (!response.isError) {
                                this.successMsg(Vue.i18n.translate('messages.file_uploaded'));
                                resolve();
                            } else {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                                });
                                reject();
                            }
                        });
                    }
                }
                    
                resolve();
            });
        },
        async waitToUploadDocuments() {
            await this.uploadDocuments();
        },
        viewImage(user_signature) {
            if (this.hasFilesReadPermission && typeof this.user_signature != 'undefined' && this.user_signature != null) {
                this.file_id = user_signature.id;
                http.route('get_content/file/'+user_signature.id+'/'+user_signature.file_name).viewImage({}, '').then(res => {
                    if (res) {
                        this.userSignature = res;
                    }
                });
            }
        },
        onDownloadFile () {
            if (this.file_id != null) {
                let data = http.route('file/' + this.file_id).get(
                {
                    export_pdf: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                        let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                    } else {
                        this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                    }
                });
            }
        },
        onDownloadProfilePicture () {
            http.route('get_content/avatar/null/null').downloadPdf({}, this.profile_picture_name).then(res => {});
        },
        onDeleteFile () {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        onDeleteProfilePicture () {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_profile_picture');
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.$store.dispatch('getUser');
                            this.userSignature = null;
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route('user/remove_profile_picture/' + this.$store.state.user.user.id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.successMsg(Vue.i18n.translate('messages.profile_picture_deleted'));
                            this.$store.dispatch('getUser');
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }

            this.$refs.deleteModal.hide();
        },
    }
}
</script>

<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
    .dropzone .dz-preview {
        min-height: 200px;
        min-width: 150px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/users/profile/profile_change.vue